var fails = require('../internals/fails');

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/native-symbol.js
// module id = 168
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35